let checkSpecificKey = (rule, value, callback) => {
    let specialKey = "[`~!#$^&*()=|{}':;',\\[\\]<>?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
    for (let i = 0; i < value.length; i++) {
        if (specialKey.indexOf(value.substr(i, 1)) !== -1) {
            callback(new Error("存在特殊字符"));
        }
    }
    callback();
};

let checkNumber = (rule, value, callback) => {
    if (typeof parseInt(value) !== "number") {
        callback(new Error("这是必填字段且必须为数字类型"));
    } else {
        callback();
    }
};


export default {checkSpecificKey, checkNumber}